export default "__VITE_ASSET__CQ3SlIps__"